package org.hs_soft.runmynesto.domain.util

import kotlinx.browser.window
import org.jetbrains.compose.web.css.CSSNumericValue
import org.jetbrains.compose.web.css.CSSUnitTime
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.s


object Constants {

    const val ipRegex="""\b((25[0-5]|2[0-4][0-9]|[01]?
                                |[0-9][0-9]?)(\.|$)){4}\b"""
    const val sunmiTypeLength=13
    const val requiredPriceCategories=10
    const val maxArticleItems=400
    const val showTooltipDelay=100
    const val showTooltipLongDelay=1300
    const val opacityForDisableItems=0.25
    const val pageFadingTime=1000L
    const val stDot="ST."
    const val hr="hr"
    const val limitItemsForPagination=100
    const val SearchRequestDelay=1500L
    const val sunmiSerialLength=13
    const val infiniteScrollRatio=1.5
    const val fetchItemsStep=50
    const val MFA_LENGTH=6
    const val RESET_PASSWORD_CODE_Length=6
    const val timeout:Long= 60000L
    const val databaseVersion=1
    const val startYear=2024
    const val endYear=2030
    const val closingReportsCalendarStartYear=2020
    const val closingReportsCalendarEndYear=2024
    const val maxReceiveTemplateImgSize=150
    const val delayLoadingCircle=1000L
    const val delayDefaultProcess=1000L
    const val delayGenerateMenuCard=20000L
    val editTextTransition: CSSNumericValue<out CSSUnitTime> = 1000.ms
    const val fastExpandingTime: Double=0.3
    const val mediumExpandingTime:Double=0.5
    const val slowExpandingTime: Double=1.0
    const val verySlowExpandingTime:Double=1.5
    const val expandingTimeOut=600
    const val touchTime=200L
    val fastTransition=0.3.s
    val mediumTransition=0.5.s
    const val searchDelay=300
    const val minPassLen=8

    object AppDefaultValues{
        const val salesGroupNumber="1001"
        const val salesGroupId="1"
        const val salesGroupReceipeName="Küche"
        const val templateName="Favoriten"
        const val templatePosition=1
        const val productName="Beispiel"
        const val productActivation=true
        const val productNumber="1"
        const val productSalesGroup="1001 Küche"
        val productPrice= listOf<Double?>(
            11.15,null,null,null,null,null
        )
        const val optionCashFlowName1="EFT"
        const val optionCashFlowName3="Rechnung"
        const val optionCashFlowName5="Gutschein"
        const val printerLocation1Number=1
        const val printerLocation1Name="Küche"
        const val printerLocation2Number=2
        const val printerLocation2Name="Buffet"
    }

    object ZIndex{
        const val largestZIndex=8f
        const val extraExtraLargeZIndex=7f
        const val extraLargeZIndex=6f
        const val largeZIndex=5f
        const val semiLargeZIndex=4f
        const val mediumZIndex=3f
        const val normalZIndex=2f
        const val smallZIndex=1f
    }
    object RestaurantDesign{
        const val objectType="object"
    }

    object Responsive{
        const val restaurantProjectHeight=50
        val ClosingReportsTablePhone= (window.innerWidth*0.90)
        val ClosingReportsTableTablet= (window.innerWidth*0.50)
        val ClosingReportsCheckoutTablet=(window.innerWidth*0.40)
        const val menuCardTableContentHeight=70
        const val closingReportsCheckoutHeight=30
        const val dialogPhoneResize=0.5
        const val KitchenTableHeaderWidth=12
        const val checkoutPhoneRatio=0.8
        const val checkoutTabletRatio=0.50
        const val gridPhoneRatio=0.90
        const val girdTabletRatio=0.40
        const val SwipeWidth: Double=80.0
        const val MaxPhoneWidth=576
        const val MaxTabletWidth=1200



    }

    object ReceiptPrinters {
        const val sunmiIntegrated = "SUNMI Integrated Printer"
        const val sunmiCloud = "SUNMI Cloud Printer"
    }

    const val ipAddressRegex = """^((25[0-5]|2[0-4][0-9]|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4][0-9]|1\d{2}|[1-9]?\d)$"""

    object KitchenStationTemplates {
        const val ip: String = "kitchenStation%s_IP"
        const val id: String = "kitchenStation%s_ID"
    }

}
